import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { Loader } from '@/components/ui/loader/Loader';
import { CSSTransition } from 'react-transition-group';

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { isLoading, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(isLoading);
  const nodeRef = useRef(null);

  useEffect(() => {
    if (isLoading) {
      setIsVisible(true);
    } else {
      const timer = setTimeout(() => setIsVisible(false), 600);
      return () => clearTimeout(timer);
    }
  }, [isLoading]);

  useEffect(() => {
    if (!isVisible && !isAuthenticated) {
      navigate('/signin');
    }
  }, [isVisible, isAuthenticated, navigate]);

  if (!isLoading && isAuthenticated) {
    return <>{children}</>;
  }

  return (
    <CSSTransition
      in={isVisible}
      timeout={{ enter: 300, exit: 300 }}
      classNames={{
        enter: 'opacity-0',
        enterActive: 'opacity-100 transition-opacity duration-300',
        exit: 'opacity-100',
        exitActive: 'opacity-0 transition-opacity duration-300',
      }}
      unmountOnExit
      nodeRef={nodeRef}
    >
      <div
        ref={nodeRef}
        className="flex items-center justify-center h-screen"
      >
        <Loader size="lg" title="Loading..." />
      </div>
    </CSSTransition>
  );
};
